import useAuthStore from '~/store/auth'

export default defineNuxtRouteMiddleware(() => {
  const { isCEO } = storeToRefs(useAuthStore())

  if (!isCEO.value) {
    return navigateTo({
      name: 'dashboard',
    })
  }
})
